import { FC } from 'react';
import { DateRangeFilter } from '@new/common/ui/DateRangeFilter/DateRangeFilter';
import { useProjectsReview } from '../../contexts/ProjectsReviewProvider';

export const ProjectsDateFilter: FC = () => {
  const { dateFrom, setDateFrom, dateTo, setDateTo } = useProjectsReview();

  return (
    <DateRangeFilter
      dateFrom={dateFrom}
      dateTo={dateTo}
      onDateFromChange={setDateFrom}
      onDateToChange={setDateTo}
    />
  );
};
